export default __webpack_public_path__ + "static/media/20210430_235456-min.3a9975e8.jpg";